import { render, staticRenderFns } from "./SearchEvents.vue?vue&type=template&id=166ff76d&scoped=true&"
import script from "./SearchEvents.vue?vue&type=script&lang=js&"
export * from "./SearchEvents.vue?vue&type=script&lang=js&"
import style0 from "./SearchEvents.vue?vue&type=style&index=0&id=166ff76d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166ff76d",
  null
  
)

export default component.exports